import { URL_LABEL } from "../index.content";

const blog = (language) => ({
  url: `${language === "de" ? "/de" : ""}/blog?${URL_LABEL}`,
});

export default blog;
